import axios, { AxiosRequestConfig } from 'axios';

export default class RestClient {
    static async call(extraRequest: AxiosRequestConfig, baseURL?: string) {
        const request: AxiosRequestConfig = {
            baseURL: baseURL || process.env.VUE_APP_API_TRACKING_SERVER_URL,
            headers: {
                'Authorization': localStorage.getItem("token")
            },
            ...extraRequest
        }
        return axios.request(request)
    }
}